import styled from "styled-components"
import FloodVictims7 from "../assets/images/flood-victims-7.jpg"
import HeaderLinks from "../components/HeaderLinks"

const HeroImageContainer = styled.div`
  height: 30rem;
  position: relative;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const DonateBanner = () => {
  return (
    <div>
      <HeroImageContainer>
        <HeaderLinks/>
        <Image src={FloodVictims7} alt="Flood victims"/>
      </HeroImageContainer>
    </div>
  )
}

export default DonateBanner